import React from 'react'
import { find } from 'lodash/fp'
import { LoaderCircleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useAllUsersQuery } from '@/entities/user/api/queries'
import { getUsername } from '@/entities/user/lib/utils'

export default function UsernameById({ userId }: { userId: string }) {
	const { t } = useTranslation()

	const { data: users, isLoading } = useAllUsersQuery()
	const user = find({ id: userId }, users)

	return isLoading ? (
		<LoaderCircleIcon className='inline-block size-4 animate-spin text-muted-foreground' />
	) : user ? (
		getUsername(user)
	) : (
		t('app.unknown', { defaultValue: 'Unknown' })
	)
}
